import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export default class OrderPaymentsListItem {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  createDate!: string;
  @IsNumber()
  @Expose()
  amount!: number;
  @IsNumber()
  @Expose()
  amountInCurrency!: number;
  @IsString()
  @Expose()
  formOfPaymentName!: string;
  @IsString()
  @Expose()
  paymentDate!: string;
  @IsOptional()
  @IsString()
  @Expose()
  description!: null | string;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString({ each: true })
  @Expose()
  linkDocumentNumbers!: Array<string>;
  @Expose()
  currency!: string;
  @IsNumber()
  @Expose()
  recordStampId!: number;
}
